import { genId } from '@/components/canvas/store/helpers';
import type { CutdownCardBlock } from '@/components/canvas/blocks/types';

const DEFAULT_WIDTH = 320;
const DEFAULT_HEIGHT = 80;

export function createCutdownCardBlock(config: {
  id?: string;
  x: number;
  y: number;
  width?: number;
  height?: number;
  zIndex?: number;
  date?: string;
  name?: string;
}): CutdownCardBlock {
  return {
    id: config.id ?? genId('cutdown-card'),
    type: 'cutdown-card',
    name: config.name ?? '倒计时',
    layout: {
      x: config.x,
      y: config.y,
      width: config.width ?? DEFAULT_WIDTH,
      height: config.height ?? DEFAULT_HEIGHT,
      zIndex: config.zIndex ?? 1,
    },
    data: {
      ...(config.date ? { date: config.date } : {}),
      layout: 'horizontal',
      animate: true,
    },
  };
}
